import { render, staticRenderFns } from "./Sim.vue?vue&type=template&id=280f3578&scoped=true"
import script from "./Sim.vue?vue&type=script&lang=js"
export * from "./Sim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280f3578",
  null
  
)

export default component.exports